document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
      }).format(value);
    } catch (e) {
      return `Rs. ${value.toFixed(2)} INR`;
    }
  };

  document.querySelectorAll('[data-mck-product-main]').forEach((root) => {
    const mainImage = root.querySelector('[data-main-product-image]');
    const variantInput = root.querySelector('[data-variant-id-input]');
    const selectedColor = root.querySelector('[data-selected-color]');
    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const discountBadge = root.querySelector('[data-discount-badge]');
    const discountMini = root.querySelector('[data-discount-mini]');
    const addButton = root.querySelector('[data-add-to-cart-button]');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const buyNowWrap = root.querySelector('[data-buy-now-wrap]');
    const form = root.querySelector('form[action*="/cart/add"]');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyAdd = root.querySelector('[data-sticky-add]');

    root.querySelectorAll('.mck-thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage && thumb.dataset.imageSrc) {
          mainImage.src = thumb.dataset.imageSrc;
          mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
        }
        root.querySelectorAll('.mck-thumb').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const tabs = root.querySelector('[data-mck-tabs]');
    if (tabs) {
      tabs.querySelectorAll('[data-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          const tab = button.dataset.tab;
          tabs.querySelectorAll('[data-tab]').forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          tabs.querySelectorAll('[data-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.panel === tab));
          if (window.matchMedia('(max-width: 989px)').matches) {
            button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }

    const variantsEl = root.querySelector('[data-product-variants-json]');
    let variants = [];
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
    } catch (error) {
      variants = [];
    }

    const colorIndex = parseInt(root.dataset.colorOptionIndex || '0', 10);

    const setActiveThumbByMedia = (mediaId, imageSrc) => {
      let activated = false;
      if (mediaId) {
        root.querySelectorAll('.mck-thumb').forEach((thumb) => {
          const isMatch = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', isMatch);
          if (isMatch) activated = true;
        });
      }
      if (!activated && imageSrc) {
        root.querySelectorAll('.mck-thumb').forEach((thumb) => {
          const isMatch = thumb.dataset.imageSrc && imageSrc && thumb.dataset.imageSrc.split('?')[0].includes(imageSrc.split('/').pop().split('?')[0]);
          thumb.classList.toggle('is-active', isMatch);
        });
      }
    };

    const updateUIForVariant = (variant, value) => {
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (selectedColor && value) selectedColor.textContent = value;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);
      const hasDiscount = compareAt > price;
      const discount = hasDiscount ? Math.round(((compareAt - price) * 100) / compareAt) : 0;

      if (compareEl) {
        compareEl.textContent = hasDiscount ? formatMoney(compareAt) : '';
        compareEl.classList.toggle('is-hidden', !hasDiscount);
      }
      [discountBadge, discountMini].forEach((el) => {
        if (!el) return;
        el.textContent = hasDiscount ? `${discount}% OFF` : '';
        el.classList.toggle('is-hidden', !hasDiscount);
      });

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.classList.toggle('is-disabled', !variant.available);
      }
      if (addText) addText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (buyNowWrap) buyNowWrap.classList.toggle('is-disabled', !variant.available);

      const featuredImage = variant.featured_image || null;
      const imageSrc = featuredImage && featuredImage.src ? featuredImage.src : null;
      if (mainImage && imageSrc) {
        const sizedSrc = imageSrc.includes('?') ? imageSrc : `${imageSrc}?width=1200`;
        mainImage.src = sizedSrc;
        mainImage.alt = (featuredImage.alt || value || mainImage.alt || '').trim();
        setActiveThumbByMedia(featuredImage.id, imageSrc);
      }

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }

      if (form) {
        form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      }
    };

    const findVariantForColor = (value) => {
      const normalized = String(value || '').toLowerCase();
      return variants.find((variant) => {
        return variant.available && variant.options && variant.options[colorIndex] && String(variant.options[colorIndex]).toLowerCase() === normalized;
      }) || variants.find((variant) => {
        return variant.options && variant.options[colorIndex] && String(variant.options[colorIndex]).toLowerCase() === normalized;
      }) || variants.find((variant) => {
        return variant.available && variant.options && variant.options.some((option) => String(option).toLowerCase() === normalized);
      }) || variants.find((variant) => {
        return variant.options && variant.options.some((option) => String(option).toLowerCase() === normalized);
      });
    };

    root.querySelectorAll('.mck-color-swatch').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const value = swatch.dataset.optionValue || '';
        const matched = findVariantForColor(value);
        if (!matched) return;

        root.querySelectorAll('.mck-color-swatch').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-checked', 'false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-checked', 'true');

        updateUIForVariant(matched, value);
      });
    });

    if (form && addButton) {
      form.addEventListener('submit', () => {
        if (addButton.disabled) return;
        addButton.classList.add('is-loading');
        if (addText) addText.textContent = 'Adding...';
        setTimeout(() => {
          addButton.classList.remove('is-loading');
          if (addText && !addButton.disabled) addText.textContent = 'Add to Cart';
        }, 3500);
      });
    }

    root.querySelectorAll('[data-copy-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.copyCode;
        try {
          await navigator.clipboard.writeText(code);
          const oldText = button.textContent;
          button.textContent = 'Copied';
          setTimeout(() => { button.textContent = oldText; }, 1300);
        } catch (error) {
          button.textContent = code;
        }
      });
    });

    // Sticky mobile add-to-cart bar: show once the real buy row scrolls above the viewport
    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      const sentinel = root.querySelector('.mck-buy-row') || addButton;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const scrolledPast = entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    }
    if (stickyAdd && addButton) {
      stickyAdd.addEventListener('click', () => {
        if (addButton.disabled) return;
        addButton.click();
      });
    }

    // Desktop cursor-following gallery zoom
    const imgWrap = root.querySelector('.mck-main-image-wrap');
    if (imgWrap && mainImage && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      imgWrap.addEventListener('mouseenter', () => imgWrap.classList.add('is-zooming'));
      imgWrap.addEventListener('mouseleave', () => {
        imgWrap.classList.remove('is-zooming');
        mainImage.style.transformOrigin = 'center center';
      });
      imgWrap.addEventListener('mousemove', (e) => {
        const r = imgWrap.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        mainImage.style.transformOrigin = x + '% ' + y + '%';
      });
    }
  });
});
